<template>
    <div
        :data-component="$options.name"
        class="relative"
    >
        <div
            data-jest-toggle
            @click="toggleVisibility"
        >
            <ms-information-circle
                class="cursor-pointer w-lh-text-mobile h-lh-text-mobile text-color-neutral-grey-40"
            />
        </div>
        <div
            v-if="isVisible"
            class="absolute right-0 p-20 bg-white border-t-2 border-solid rounded cursor-auto ms-tooltip top-30 border-t-petrol"
        >
            <span
                class="absolute w-24 h-24 cursor-pointer right-15"
                data-jest-close
                @click="closeTooltip"
            >
                <ms-close />
            </span>
            <slot name="headline" />
            <slot name="text" />
        </div>
    </div>
</template>
<script lang="ts" src="./MsTooltip.ts" />
<style scoped lang="scss" src="./MsTooltip.scss" />
